import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type ThemePreference = 'system' | 'light' | 'dark';
export type ResolvedTheme = 'light' | 'dark';

interface ThemeState {
  preference: ThemePreference;
  resolved: ResolvedTheme;
  setPreference: (pref: ThemePreference) => void;
}

function resolveSystem(): ResolvedTheme {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return 'dark';
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function resolve(pref: ThemePreference): ResolvedTheme {
  if (pref === 'light') return 'light';
  if (pref === 'dark') return 'dark';
  return resolveSystem();
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      // Default to 'dark' rather than 'system' so the wallet always
      // starts in its historical look. Settings → Appearance lets the
      // user explicitly opt into Light or System matching.
      preference: 'dark',
      resolved: 'dark',
      setPreference: (pref) => {
        set({ preference: pref, resolved: resolve(pref) });
      },
    }),
    {
      name: 'gonka.theme',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ preference: state.preference }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.resolved = resolve(state.preference);
        }
      },
    },
  ),
);
